import { UNIT } from '../../constants/configuration';

const styles = {
  textStyle: {
    fontSize: UNIT * 1.125
  }
};

export default styles;
